package br.com.htms.inspeccaocampo.platform

import kotlin.js.Date
import kotlin.random.Random
import kotlinx.browser.localStorage
import kotlinx.browser.window

actual fun currentTimeMillis(): Long = Date().getTime().toLong()

actual fun randomUuid(): String {
    val hex = "0123456789abcdef"
    fun r(n: Int) = (1..n).map { hex[Random.nextInt(16)] }.joinToString("")
    return "${r(8)}-${r(4)}-4${r(3)}-${hex[8 + Random.nextInt(4)]}${r(3)}-${r(12)}"
}

actual fun formatDateBr(epochMs: Long): String {
    val d = Date(epochMs.toDouble())
    fun p(n: Int) = n.toString().padStart(2, '0')
    return "${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}"
}

actual fun platformName(): String = "Web"

actual fun notifyAppContentReady() {
    js("window['__ICD_UI_READY__'] = true")
}

actual fun rotuloPortalDoEndereco(): String? {
    val host = window.location.hostname.lowercase()
    return if (host.contains("portal-htmsenergia")) "Portal HTMS Energia" else null
}

private const val TEMA_CHAVE = "icd_tema"

actual fun lerTemaEscuro(): Boolean = localStorage.getItem(TEMA_CHAVE) == "escuro"

actual fun gravarTemaEscuro(escuro: Boolean) {
    localStorage.setItem(TEMA_CHAVE, if (escuro) "escuro" else "claro")
}
